/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2023-02-14 11:32:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-14 11:32:47
 * @Description: 夸组件通讯
 */
 
import PubSub from 'pubsub-js';
 
export function useSubscribe (msg, callback) {
    return PubSub.subscribe(msg, callback);
}
export function usePublish () {
    return PubSub.publish;
}
export function useUnsubscribe () {
    return PubSub.unsubscribe;
}
 